// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import {
    createHandlerChainRunner,
    Handler,
    HasOnError,
    HasOnSuccess,
    markSkipOnCompleteIfOnErrorIsSet,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@insite/client-framework/HandlerCreator";
import { MyAccountAddressApiParameter, submitVmShipToAddress } from "@vanmeter/App/Services/MyAccountAddress";

type Parameter = MyAccountAddressApiParameter & HasOnSuccess & HasOnError<unknown>;

type Props = {
    apiParameter: MyAccountAddressApiParameter;
    error?: unknown;
};

type HandlerType = Handler<Parameter, Props>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = { addressModel: props.parameter.addressModel, file: props.parameter.file };
};

export const SubmitVmShipToAddress: HandlerType = async props => {
    const result = await submitVmShipToAddress(props.apiParameter);
    if (!result.successful) {
        props.error = result.errorMessage;
    }
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    if (!props.error) {
        markSkipOnCompleteIfOnSuccessIsSet(props);
        props.parameter.onSuccess?.();
    }
};

export const ExecuteOnErrorCallback: HandlerType = props => {
    if (props.error) {
        markSkipOnCompleteIfOnErrorIsSet(props);
        props.parameter.onError?.(props.error);
    }
};

export const chain = [PopulateApiParameter, SubmitVmShipToAddress, ExecuteOnSuccessCallback, ExecuteOnErrorCallback];

const submitMyAccountAddress = createHandlerChainRunner(chain, "submitMyAccountAddress");
export default submitMyAccountAddress;
